import { render, staticRenderFns } from "./ActiveBulkPromotions.vue?vue&type=template&id=fe1eb046&"
import script from "./ActiveBulkPromotions.vue?vue&type=script&lang=js&"
export * from "./ActiveBulkPromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports